module.exports = __webpack_public_path__ + "img/bostie_and_leash.d34cb9ba.svg";